import { adminCurrencyFormValues } from "@/schemas/currency";
import { createData, deleteData, fetchData, updateData } from "../api-service";

export type AdminCurrency = {
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  createdBy: string;
  updatedBy: string;
  id: number;
  displayName: string;
  currencyCode: string;
  fromCurrencyExchangeRateList: FromCurrencyExchangeRateList[];
  toCurrencyExchangeRateList: FromCurrencyExchangeRateList[];
  paymentOrderList: PaymentOrderList[];
};

interface PaymentOrderList {
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  createdBy: string;
  updatedBy: string;
  id: string;
  totalAmount: number;
  checkOutAmount: number;
  payload: Payload;
  paymentReferenceId: string;
  remark: string;
  description: string;
  currency: string;
  exchangeRateHistory: ExchangeRateHistoryList;
  user: User;
  paymentTransactionList: PaymentTransactionList[];
}

interface PaymentTransactionList {
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  createdBy: string;
  updatedBy: string;
  id: number;
  amount: number;
  paymentReferenceId: string;
  payload: Payload;
  status: string;
}

interface Payload {
  additionalProp1: AdditionalProp1;
  additionalProp2: AdditionalProp1;
  additionalProp3: AdditionalProp1;
}

interface AdditionalProp1 {}

interface FromCurrencyExchangeRateList {
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  createdBy: string;
  updatedBy: string;
  id: number;
  amount: number;
  fromCurrency: string;
  toCurrency: string;
  user: User;
  exchangeRateHistoryList: ExchangeRateHistoryList[];
}

interface ExchangeRateHistoryList {
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  createdBy: string;
  updatedBy: string;
  id: number;
  amount: number;
  paymentOrderList: string[];
}

interface User {
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  createdBy: string;
  updatedBy: string;
  id: string;
  name: string;
  email: string;
  username: string;
  password: string;
  phoneNumber: string;
}

export const ADMIN_CURRENCY_ENDPOINT = "/admin/currency";

export type AdminCurrencyDto = {
  nonce: string;
  payload: adminCurrencyFormValues;
};

export const adminCurrencyApi = {
  // Get a single admin currency by ID
  getById: (id: number) =>
    fetchData<AdminCurrency>(`${ADMIN_CURRENCY_ENDPOINT}/${id}`),

  // Create a new admin currency
  create: (data: AdminCurrencyDto) =>
    createData<AdminCurrency>(ADMIN_CURRENCY_ENDPOINT, data),

  // Update an existing admin currency
  update: (id: number, data: AdminCurrencyDto) =>
    updateData<AdminCurrency>(`${ADMIN_CURRENCY_ENDPOINT}`, id, data),

  // Delete an admin currency
  delete: (id: number) => deleteData(`${ADMIN_CURRENCY_ENDPOINT}`, id),
};
